const capitalize = (str: string) => (str.length > 1 ? str[0].toUpperCase() + str.slice(1) : str.toUpperCase())

export default capitalize
